import InlineButton from 'components/generic/InlineButton';
import useLoginLink from 'hooks/user/useLoginLink';
import loadHtmlModalFunc from 'modules/modal/helpers';
import UAEventTracking, { type TrackingAction } from 'modules/tracking/UAEventTracking';
import Default from 'modules/modal/layouts';
import { bindComponents } from 'modules/modalLink';
import { firstCharacterToLower } from 'modules/helpers/strings';
import { useTranslation } from 'react-i18next';
import { LoginToGetDiscount } from 'autogen/translation-keys/trans-website-basket';
import { FontSize12 } from 'autogen/design-tokens/tokens';
import styled from 'styled-components';
import InlineLinkActionButton from 'components/generic/InlineButton/InlineLinkActionButton';

const StyledInlineLinkActionButton = styled(InlineLinkActionButton)`
    font-size: ${FontSize12};
`;

const StyledInlineButton = styled(InlineButton)`
    font-size: ${FontSize12};
`;

export default function LoginActions() {
    const { loginLinkAction, loginModal } = useLoginLink();
    const { t } = useTranslation();

    if (loginModal && loginLinkAction) {
        return (
            <StyledInlineButton
                size="sm"
                onClick={async () => {
                    const htmlModal = await loadHtmlModalFunc();
                    const modal = htmlModal({ layout: { component: (props) => <Default {...props} /> } });
                    modal({ url: loginLinkAction.url, onAfterContent: bindComponents });

                    UAEventTracking({
                        eventCategory: 'checkout',
                        eventAction: firstCharacterToLower(loginModal.trackingAction) as TrackingAction
                    });
                }}
            >
                {t(LoginToGetDiscount)}
            </StyledInlineButton>
        );
    }

    if (loginLinkAction) {
        return (
            <StyledInlineLinkActionButton size="sm" action={loginLinkAction}>
                {t(LoginToGetDiscount)}
            </StyledInlineLinkActionButton>
        );
    }

    return null;
}
